import { Col, Row, Skeleton } from 'ui';

const GiveOptionsSkeleton = () => (
  <Row gutter={[0, 'xs']}>
    {Array.from({ length: 12 }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      <Col key={index} span={24}>
        <Skeleton paragraph={{ rows: 4 }} />
      </Col>
    ))}
  </Row>
);

export default GiveOptionsSkeleton;
